/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from "react";
import {Modal, ModalHeader, ModalBody} from "reactstrap";
import usePresupuesto from "../../hooks/usePresupuesto";
import ModaladdPadre from "./Modals/ModalPadre";
import ModalSubpadre from "./Modals/ModaSubpadre";
import ModalHijo from "./Modals/ModalHijo";
import ModalFechas from "./Modals/ModalFecha";
import ModalVerConcepto from "./Modals/ModalVerConcepto";
import ModalEditarConcepto from "./Modals/ModalEditarConcepto";
import ModalEditar from "./Modals/ModalEditarCampo";
import ModalElim from "./Modals/ModalEliminar";
import ModalEditarPre from "./Modals/ModalEditarCuenta";
import ModalAddAportacion from "./Modals/ModalAportacion";
import GroupedTable from "../../components/DataTable/GroupedTable";
import {hideLoader, showLoader, setTitle} from "../../reducers/loaderReducer";
import {useDispatch} from "react-redux";
import useLogin from "../../hooks/useLogin";
import useProyectos from "../../hooks/useProyectos";
import Swal from "sweetalert2";
import {useParams, Link as LinkReact} from "react-router-dom";
import "./ExcelStyles.css";
import Title from "../../components/Form/Title";
import CeldaEditable from "../../components/DataTable/CeldaEditable";
import FilaNueva from "../../components/Presupuesto/FilaNueva";
import {PresupuestosPadreUpdate} from "../../service/presupuesto";
import {HijosSubAdd, HijosHijosAdd_, PadreCuenta, hijosCuenta} from "../../service/hijos";
import {PadreAdd} from "../../service/padre";
import {PresupuestosOrden, PresupuestoExportar} from "../../service/presupuesto";
import {ProveedorGet} from "../../service/proveedor";
import BotonesExcel from "../../components/Presupuesto/BotonesExcel";
import VersionesPresupuesto from "../../components/Presupuesto/VersionesPresupuesto";

export default function Index() {
  const { token, user_rol, cliente_id } = useLogin();
  const {id} = useParams();
  const dispatch = useDispatch();
  const { loading, message, success, Presupuestos, PresupuestosGetService, PadresMontoGetService } = usePresupuesto();

  const {Proyecto, ProyectoGetService} = useProyectos();
  const canManage = user_rol === "super administrador" || user_rol === "cliente";
  const [exportando, setExportando] = useState(false);

  useEffect(() => {
    if (id) {
      ProyectoGetService(id, token);
    }
  }, [id, ProyectoGetService]);

  const [ProveedoresReales, setProveedoresReales] = useState([]);
  useEffect(() => {
    ProveedorGet(0, token).then((respuesta) => {
      setProveedoresReales(respuesta ?? []);
    });
  }, [token]);

  const [Padre, setPadre] = useState([]);
  const [PadreID, setPadreID] = useState("");
  const [HijoID, setHijoID] = useState("");
  const [NombreH, setNombreH] = useState("");
  const [NivelID, setNivelID] = useState("");
  const [VariableID, setVariableID] = useState("");

  /*
   * Editar Campos
   */
  const [ModalEditarCampo, setModalEditarCampo] = useState(false);
  const [Campo, setCampo] = useState("");
  const [ValorCampo, setValorCampo] = useState("");
  const [IDCampo, setIDCampo] = useState("");
  const [Tipo, setTipo] = useState("");

  useEffect(() => {
    if (success == true) {
      PresupuestosGetService(id, token);
    }
  }, [PresupuestosGetService, success]);

  /*
   * Agregar Padre
   */
  const [ModalPadre, setModalPadre] = useState(false);
  const [IDPadre, setIDPadre] = useState("");
  const [UpdatePadre, setUpdatePadre] = useState(false);
  const [NombrePadre, setNombrePadre] = useState("");
  const [NumeracionPadre, setNumeracionPadre] = useState("");
  const [NivelPadre, setNivelPadre] = useState(1);
  const [GrupoPadre, setGrupoPadre] = useState("");
  /*
   * Agregar Subpadre
   */
  const [ModalSub, setModalSub] = useState(false);
  const [NombreSub, setNombreSub] = useState("");
  /*
   * Agregar hijo
   */
  const [modalHijo, setmodalHijo] = useState(false);
  const [NombreVari, setNombreVari] = useState("");
  const [NumeracionVari, setNumeracionVari] = useState("");
  const [Cantidad, setCantidad] = useState(0);
  const [Unidades, setUnidades] = useState("");
  const [X, setX] = useState(0);
  const [MostrarVariable, setMostrarVariable] = useState(false);
  const [IsChecked, setIsChecked] = useState(true);
  const [Fecha, setFecha] = useState("");
  const [Opcion, setOpcion] = useState([]);
  const [Cuantos, setCuantos] = useState(0);
  const [Costo, setCosto] = useState(0);
  const [Subtota, setSubtota] = useState(0);
  const [Iva, setIva] = useState(0);
  const [Total, setTotal] = useState(0);

  /*
   * Estados Fecha
   */
  const [ModalFecha, setModalFecha] = useState(false);
  const [IDFecha, setIDFecha] = useState("");

  /*
   * Ver detalle de un concepto
   */
  const [ModalVer, setModalVer] = useState(false);
  const [ConceptoVer, setConceptoVer] = useState(null);

  /*
   * Editar concepto
   */
  const [ModalEditarConceptoAbierto, setModalEditarConceptoAbierto] = useState(false);
  const [ConceptoEditar, setConceptoEditar] = useState(null);

  /*
   * Eliminar Cuenta
   */
  const [ModalEliminar, setModalEliminar] = useState(false);
  const [Cuenta, setCuenta] = useState("");
  const [NomCuenta, setNomCuenta] = useState("");
  const [IDCuenta, setIDCuenta] = useState("");
  const [CuentaTipo, setCuentaTipo] = useState("");

  /*
   * Editar Presupuesto
   */
  const [ModalEditarPresu, setModalEditarPresu] = useState(false);
  const [IdPresupuesto, setIdPresupuesto] = useState("");

  /*
   * Editar Aportacion
   */
  const [ModalAportacion, setModalAportacion] = useState(false);
  const [Monto, setMonto] = useState(0);
  const [IdAportacion, setIdAportacion] = useState("");

  useEffect(() => {
    PresupuestosGetService(id, token);
  }, [PresupuestosGetService, id]);

  useEffect(() => {
    if (Presupuestos.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
  }, [Presupuestos]);

  useEffect(() => {
    dispatch(setTitle("Descargando presupuestos"));
    dispatch(showLoader());
    PadresMontoGetService(id, token);
  }, [PadresMontoGetService, id]);

  useEffect(() => {
    setPadre([]);
  }, [id]);


  const formatNumber = (number) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

  const formatCurrency = (value) => "$" + formatNumber(value || 0);

  /**
   * Importe de una subcuenta en la tabla del árbol.
   *
   * Las filas que agrupan no traen montos propios: valen lo que suman las que
   * cuelgan de ellas. Es la misma regla que usa el API para el total de cada
   * cuenta, así que las dos cifras siempre cuadran.
   */
  const sumaDeRama = (fila, campo) => {
    const propio = parseFloat(fila[campo]);

    if (fila.subpadre !== "Si" && !Number.isNaN(propio)) {
      return propio;
    }

    return (fila.children || []).reduce(
      (suma, hija) => suma + sumaDeRama(hija, campo),
      0
    );
  };



  const togglePadre = () => {
    setModalPadre(!ModalPadre);
    setUpdatePadre(false);
    setIDPadre("");
    setNombrePadre("");
    setNumeracionPadre("");
    setNivelPadre("");
    setGrupoPadre("");
  };

  const toggleSubPadre = () => {
    setModalSub(!ModalSub);
    setPadreID("");
    setHijoID("");
    setNombreSub("");
    setNivelID("");
  };

  const toggleHijo = () => {
    setmodalHijo(!modalHijo);
    setPadreID("");
    setHijoID("");
    setNombreH("");
    setNivelID("");
    setVariableID("");
    setCantidad("");
    setUnidades("");
    setX("");
    setMostrarVariable(false);
    setNombreVari("");
    setNumeracionVari("");
    setIsChecked(true);
    setFecha("");
    setOpcion("");
    setCuantos("");
    setCosto("");
    setSubtota("");
    setIva("");
    setTotal("");
  };

  const toggleFecha = () => {
    setModalFecha(!ModalFecha);
    setIDFecha("");
  };

  const toggleEliminar = () => {
    setModalEliminar(!ModalEliminar);
    setCuenta("");
    setNomCuenta("");
    setCuentaTipo("");
    setIDCuenta("");
  };

  const toggleEditar = () => {
    setModalEditarCampo(!ModalEditarCampo);
    setCampo("");
    setValorCampo("");
    setIDCampo("");
    setTipo("");
  };

  const toggleEditarPre = () => {
    setModalEditarPresu(!ModalEditarPresu);
  };

  const toggleAportacion = () => {
    setModalAportacion(!ModalAportacion);
    setMonto(0);
    setIdAportacion("");
  };

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success]);

  // El archivo lo arma el backend (mismos números que alimentan la pantalla:
  // portada, esquema financiero, desglose y flujo de efectivo). Antes este
  // botón generaba un Excel aparte en el navegador, con una sola hoja armada
  // a mano y un nombre de archivo fijo ("example.xlsx") que no cuadraba con
  // esos reportes.
  const generateExcel = async () => {
    setExportando(true);
    try {
      const blob = await PresupuestoExportar(id, token);
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Presupuesto - ${Proyecto?.nombre ?? id}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "No se pudo exportar",
        text: error.message || "Intenta de nuevo.",
      });
    } finally {
      setExportando(false);
    }
  };


  /** Número que se le propone a la partida nueva. */
  const siguienteNumero = (cuenta, primera) => {
    if (cuenta === null || cuenta === undefined || cuenta === "") return "";

    const texto = String(cuenta);
    if (primera) return `${texto}.1`;

    const tramos = texto.split(".");
    const ultimo = parseInt(tramos[tramos.length - 1], 10);
    if (Number.isNaN(ultimo)) return texto;

    tramos[tramos.length - 1] = ultimo + 1;
    return tramos.join(".");
  };

  // Bloque de numeración donde arranca cada clasificación cuando todavía no
  // tiene ninguna cuenta (mismo criterio que ya usan los proyectos con datos
  // reales: 1100, 2000, 4000, 5000).
  const INICIO_CLASIFICACION = {
    "Arriba de la linea": 1100,
    "Produccion": 2000,
    "Post produccion": 4000,
    "Otros": 5000,
  };

  /** Siguiente número consecutivo (+100) para una cuenta padre nueva, según su clasificación. */
  const siguienteCuentaPadre = (grupo) => {
    const numeros = (Presupuestos || [])
      .filter((fila) => fila.grupo === grupo)
      .map((fila) => parseInt(fila["Cuenta presupuestal"], 10))
      .filter((n) => !Number.isNaN(n));

    if (numeros.length === 0) return String(INICIO_CLASIFICACION[grupo] ?? 1100);
    return String(Math.max(...numeros) + 100);
  };

  /**
   * Guardar un dato editado en la propia tabla.
   *
   * Antes cada cambio abría un modal con un solo campo; ahora se escribe en el
   * renglón y se guarda al salir. Se recarga el presupuesto para que los
   * totales de arriba queden al día.
   */
  const guardarCampo = async (idFila, campo, valor, tipo) => {
    const data = new FormData();
    data.append("id", idFila);
    data.append("ValorCampo", valor);
    data.append("Campo", campo);
    data.append("Tipo", tipo);

    const respuesta = await PresupuestosPadreUpdate(data, token);

    if (respuesta?.guardado === false) {
      Swal.fire({icon: "error", title: "No se pudo guardar", text: "Intenta de nuevo."});
      throw new Error("No se guardó");
    }

    PresupuestosGetService(id, token);
    PadresMontoGetService(id, token);
  };

  // Alta de una cuenta nueva en el renglón de arriba de la tabla.
  const [NuevaCuenta, setNuevaCuenta] = useState(false);

  /**
   * Guardar el orden nuevo después de arrastrar un renglón.
   *
   * Llegan las filas hermanas ya acomodadas; se manda la lista de ids y el
   * servidor les pone su posición. Nivel 0 son cuentas, de ahí abajo partidas.
   */
  const reordenar = async (filas, nivel) => {
    const data = new FormData();
    data.append("tipo", nivel === 0 ? "padre" : "hijo");
    data.append("ids", JSON.stringify(filas.map((fila) => fila.id)));

    // La tabla ya se acomodó sola; aquí sólo se deja guardado. No se vuelve a
    // pedir el presupuesto: eso hacía parpadear todos los renglones.
    await PresupuestosOrden(data, token);
  };

  /** Guardar la cuenta nueva del renglón de arriba. */
  const guardarCuenta = async (valores) => {
    const data = new FormData();
    data.append("proyectos_id", id);
    data.append("nombre", valores.nombre);
    data.append("numeracion", valores.cuenta);
    data.append("grupo", valores.grupo);

    const respuesta = await PadreAdd(data, token);

    if (respuesta?.guardado !== true) {
      const primerError = respuesta?.errors ? Object.values(respuesta.errors)[0] : null;
      Swal.fire({
        icon: "error",
        title: "No se pudo guardar",
        text: primerError ? primerError[0] : "Revisa los datos e intenta de nuevo.",
      });
      throw new Error("No se guardó");
    }

    setNuevaCuenta(false);
    PresupuestosGetService(id, token);
    PadresMontoGetService(id, token);
  };

  // Alta en el propio renglón. Guarda de qué fila cuelga la partida nueva, de
  // qué tipo es y qué número se le propone.
  const [Borrador, setBorrador] = useState(null);

  /** Abrir el renglón en blanco debajo de una fila. */
  const abrirBorrador = async (fila, tipo, esPadre) => {
    setBorrador({
      filaId: fila.id,
      esPadre,
      tipo,
      padreId: esPadre ? fila.id : fila.presupuestos_padre_id,
      hijoId: esPadre ? null : fila.id,
      nivelId: fila.nivel_id ?? (esPadre ? 1 : 2),
      cuentaSugerida: "",
    });

    // El número se propone con lo que ya cuelga de esa cuenta; si el servidor
    // no contesta, el campo queda vacío y se escribe a mano.
    try {
      const respuesta = esPadre
        ? await PadreCuenta({id: fila.id, token})
        : await hijosCuenta({id: fila.id, token});
      const lista = esPadre ? respuesta?.padre : respuesta?.hijos;
      const primeraVez = esPadre ? respuesta?.hijos === "no" : respuesta?.hijo === "no";

      setBorrador((actual) =>
        actual && actual.filaId === fila.id
          ? {...actual, cuentaSugerida: siguienteNumero(lista?.[0]?.cuenta_presupuental, primeraVez)}
          : actual
      );
    } catch (error) {
      // Sin sugerencia: el usuario escribe el número.
    }
  };

  /** Guardar la partida nueva del renglón en blanco. */
  const guardarBorrador = async (valores) => {
    const data = new FormData();
    const nivel = parseInt(Borrador.nivelId, 10) + 1;

    if (Borrador.tipo === "subcuenta") {
      data.append("padre_id", Borrador.padreId);
      data.append("hijos_id", Borrador.hijoId ?? "");
      data.append("items", JSON.stringify([
        {NombreSub: valores.nombre, CuentaPre: valores.cuenta},
      ]));
      data.append("nivel_id", nivel);
      data.append("subpadre", "Si");

      const respuesta = await HijosSubAdd(data, token);
      if (respuesta?.guardado !== true) {
        const primerError = respuesta?.errors ? Object.values(respuesta.errors)[0] : null;
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          text: primerError ? primerError[0] : "Revisa los datos e intenta de nuevo.",
        });
        throw new Error("No se guardó");
      }
    } else {
      // Para "concepto" FilaNueva ya arma los items (uno por cada concepto
      // que se haya agregado con el botón "+") en el formato que espera el
      // backend, así que "valores" ya llega como el arreglo completo.
      data.append("PadreID", Borrador.padreId);
      data.append("HijoID", Borrador.hijoId ?? "");
      data.append("items", JSON.stringify(valores));
      data.append("nivel_id", nivel);
      data.append("subpadre", "No");

      const respuesta = await HijosHijosAdd_(data, token);
      if (respuesta?.guardado !== true) {
        const primerError = respuesta?.errors ? Object.values(respuesta.errors)[0] : null;
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          text: primerError ? primerError[0] : "Revisa los datos e intenta de nuevo.",
        });
        throw new Error("No se guardó");
      }
    }

    setBorrador(null);
    PresupuestosGetService(id, token);
    PadresMontoGetService(id, token);
  };

  const parentColumns = [
    {
      field: "Cuenta presupuestal",
      title: "Cuenta presupuestal",
      width: 160,
      align: "center",
      render: (row) => (
        <CeldaEditable
          valor={row["Cuenta presupuestal"]}
          placeholder="Sin número"
          onGuardar={(valor) =>
            guardarCampo(row.id, "Cuenta presupuestal", valor, "padre")
          }
        />
      ),
      renderSub: (fila) => (
        <CeldaEditable
          className="gtable-cuenta-sub"
          valor={fila.cuenta_presupuental}
          placeholder="Sin número"
          onGuardar={(valor) =>
            guardarCampo(fila.id, "Cuenta presupuestal", valor, "hijo")
          }
        />
      ),
    },
    {
      field: "Nombre",
      title: "Nombre de la cuenta",
      width: 228,
      align: "center",
      render: (row) => (
        <CeldaEditable
          valor={row.Nombre}
          onGuardar={(valor) => guardarCampo(row.id, "Nombre", valor, "padre")}
        />
      ),
      renderSub: (fila) => (
        <CeldaEditable
          className="gtable-nombre-sub"
          valor={fila.Nombre ?? fila.nombre}
          onGuardar={(valor) => guardarCampo(fila.id, "Nombre", valor, "hijo")}
        />
      ),
    },
    {
      field: "proveedor",
      title: "Proveedor",
      width: 180,
      align: "center",
      filterable: false,
      render: () => null,
      renderSub: (fila) => (
        <select
          className="form-control form-control-sm"
          value={fila.proveedor_id ?? ""}
          onChange={(e) => guardarCampo(fila.id, "Proveedor", e.target.value, "hijo")}
          title="Proveedor de esta partida: hace falta para poder generar su orden de pago"
        >
          <option value="">Sin proveedor</option>
          {ProveedoresReales.map((p) => {
            const nombre = [p.nombre, p.apellido_p, p.apellido_m].filter(Boolean).join(" ");
            return (
              <option key={p.id} value={p.id}>
                {nombre}
              </option>
            );
          })}
        </select>
      ),
    },
    {
      field: "monto",
      title: "Subtotal",
      width: 140,
      filterable: false,
      align: "center",
      render: (row) => formatCurrency(row.monto),
      renderSub: (fila) => formatCurrency(sumaDeRama(fila, "subtotal")),
    },
    {
      field: "iva",
      title: "IVA",
      width: 140,
      filterable: false,
      align: "center",
      render: (row) => formatCurrency(row.iva),
      renderSub: (fila) => formatCurrency(sumaDeRama(fila, "iva")),
    },
    {
      field: "total",
      title: "Total",
      width: 140,
      filterable: false,
      align: "center",
      render: (row) => formatCurrency(row.total),
      renderSub: (fila) => formatCurrency(sumaDeRama(fila, "total")),
    },
    {
      field: "_subpadre",
      title: "Subpadre",
      width: 90,
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <button
          className="btn btn-info btn-sm btn-icon-text"
          title="Agregar subcuenta"
          onClick={() => abrirBorrador(row, "subcuenta", true)}
        >
          <i className="mdi mdi-plus-box"></i> Subcuenta
        </button>
      ),
      renderSub: (fila) => (
        <button
          className="btn btn-info btn-sm btn-icon-text"
          title="Agregar subcuenta"
          onClick={() => abrirBorrador(fila, "subcuenta", false)}
        >
          <i className="mdi mdi-plus-box"></i> Subcuenta
        </button>
      ),
    },
    {
      field: "_hijos",
      title: "Hijos",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <button
          className="btn btn-primary btn-sm btn-icon-text"
          title="Agregar concepto"
          onClick={() => abrirBorrador(row, "concepto", true)}
        >
          <i className="mdi mdi-plus-box"></i> Concepto
        </button>
      ),
      renderSub: (fila) => (
        <button
          className="btn btn-primary btn-sm btn-icon-text"
          title="Agregar concepto"
          onClick={() => abrirBorrador(fila, "concepto", false)}
        >
          <i className="mdi mdi-plus-box"></i> Concepto
        </button>
      ),
    },

  ];

  if (canManage) {
    parentColumns.push({
      field: "_delete",
      title: "Eliminar",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (row) => (
        <button
          className="btn btn-danger btn-sm btn-icon-text"
          title="Eliminar cuenta"
          onClick={() => {
            setCuenta(row["Cuenta presupuestal"]);
            setNomCuenta(row.Nombre);
            setIDCuenta(row.id);
            setCuentaTipo("padre");
            setModalEliminar(true);
          }}
        >
          <i className="mdi mdi-delete-forever"></i> Eliminar
        </button>
      ),
      // En la partida caben las cuatro cosas que se le pueden hacer: ver su
      // detalle completo, sus fechas de pago, sus aportaciones y borrarla.
      renderSub: (fila) => (
        <div className="gtable-acciones">
          {fila.subpadre === "No" && (
            <>
              <button
                className="btn btn-outline-secondary btn-sm btn-icon-text"
                title="Ver detalle"
                onClick={() => {
                  setConceptoVer(fila);
                  setModalVer(true);
                }}
              >
                <i className="mdi mdi-eye"></i>
              </button>
              <button
                className="btn btn-outline-primary btn-sm btn-icon-text"
                title="Editar concepto"
                onClick={() => {
                  setConceptoEditar(fila);
                  setModalEditarConceptoAbierto(true);
                }}
              >
                <i className="mdi mdi-pencil"></i>
              </button>
              <button
                className="btn btn-secondary btn-sm btn-icon-text"
                title="Fechas de pago"
                onClick={() => {
                  setIDFecha(fila.id);
                  setModalFecha(true);
                }}
              >
                <i className="mdi mdi-calendar"></i>
              </button>
              <button
                className="btn btn-dark btn-sm btn-icon-text"
                title="Aportaciones"
                onClick={() => {
                  setIdAportacion(fila.id);
                  setModalAportacion(true);
                }}
              >
                <i className="mdi mdi-hand-coin"></i>
              </button>
              {fila.proveedor_id && (
                <LinkReact
                  to={`/fechas-pago/${fila.proveedor_id}`}
                  className="btn btn-warning btn-sm btn-icon-text"
                  title="Orden de pago: subir factura y marcar como pagada"
                >
                  <i className="mdi mdi-cash-check"></i>
                </LinkReact>
              )}
            </>
          )}
          <button
            className="btn btn-danger btn-sm btn-icon-text"
            title="Eliminar partida"
            onClick={() => {
              setCuenta(fila.cuenta_presupuental);
              setNomCuenta(fila.Nombre ?? fila.nombre);
              setIDCuenta(fila.id);
              setCuentaTipo("hijo");
              setModalEliminar(true);
            }}
          >
            <i className="mdi mdi-delete-forever"></i>
          </button>
        </div>
      ),
    });
  }



  return (
    <>
      {ModalPadre && (
        <ModaladdPadre
          ModalPadre={ModalPadre}
          togglePadre={togglePadre}
          NombrePadre={NombrePadre}
          NumeracionPadre={NumeracionPadre}
          NivelPadre={NivelPadre}
          GrupoPadre={GrupoPadre}
          UpdatePadre={UpdatePadre}
          IDPadre={IDPadre}
          id={id}
          token={token}
          setNombrePadre={setNombrePadre}
          setNumeracionPadre={setNumeracionPadre}
          setNivelPadre={setNivelPadre}
          setGrupoPadre={setGrupoPadre}
          PresupuestosGetService={PresupuestosGetService}
          PadresMontoGetService={PadresMontoGetService}
        />
      )}

      {ModalSub && (
        <ModalSubpadre
          ModalSub={ModalSub}
          toggleSubPadre={toggleSubPadre}
          PadreID={PadreID}
          HijoID={HijoID}
          NombreSub={NombreSub}
          NivelID={NivelID}
          token={token}
          id={id}
          setPadreID={setPadreID}
          setHijoID={setHijoID}
          setNombreSub={setNombreSub}
          setNivelID={setNivelID}
          PresupuestosGetService={PresupuestosGetService}
          PadresMontoGetService={PadresMontoGetService}
        />
      )}

      {modalHijo && (
        <ModalHijo
          modalHijo={modalHijo}
          toggleHijo={toggleHijo}
          PadreID={PadreID}
          HijoID={HijoID}
          NombreH={NombreH}
          NivelID={NivelID}
          VariableID={VariableID}
          Cantidad={Cantidad}
          Unidades={Unidades}
          X={X}
          MostrarVariable={MostrarVariable}
          NombreVari={NombreVari}
          NumeracionVari={NumeracionVari}
          IsChecked={IsChecked}
          Fecha={Fecha}
          Opcion={Opcion}
          Cuantos={Cuantos}
          Costo={Costo}
          Subtota={Subtota}
          Iva={Iva}
          Total={Total}
          token={token}
          id={id}
          cliente_id={cliente_id}
          setPadreID={setPadreID}
          setHijoID={setHijoID}
          setNombreH={setNombreH}
          setNivelID={setNivelID}
          setVariableID={setVariableID}
          setCantidad={setCantidad}
          setX={setX}
          setUnidades={setUnidades}
          setMostrarVariable={setMostrarVariable}
          setNombreVari={setNombreVari}
          setNumeracionVari={setNumeracionVari}
          setIsChecked={setIsChecked}
          setFecha={setFecha}
          setOpcion={setOpcion}
          setCuantos={setCuantos}
          setCosto={setCosto}
          setSubtota={setSubtota}
          setIva={setIva}
          setTotal={setTotal}
          PresupuestosGetService={PresupuestosGetService}
          PadresMontoGetService={PadresMontoGetService}
        />
      )}

      {ModalFecha && (
        <ModalFechas
          ModalFecha={ModalFecha}
          toggleFecha={toggleFecha}
          IDFecha={IDFecha}
          token={token}
          PresupuestosGetService={PresupuestosGetService}
        />
      )}

      <ModalVerConcepto
        abierto={ModalVer}
        toggle={() => setModalVer(false)}
        concepto={ConceptoVer}
      />

      <ModalEditarConcepto
        abierto={ModalEditarConceptoAbierto}
        toggle={() => setModalEditarConceptoAbierto(false)}
        concepto={ConceptoEditar}
        token={token}
        proveedoresReales={ProveedoresReales}
        onGuardado={() => PresupuestosGetService(id, token)}
      />

      {ModalEliminar && (
        <ModalElim
          ModalEliminar={ModalEliminar}
          toggleEliminar={toggleEliminar}
          IDCuenta={IDCuenta}
          Cuenta={Cuenta}
          NomCuenta={NomCuenta}
          CuentaTipo={CuentaTipo}
          token={token}
          id={id}
          PresupuestosGetService={PresupuestosGetService}
        />
      )}
      {ModalEditarCampo && (
        <ModalEditar
          ModalEditarCampo={ModalEditarCampo}
          toggleEditar={toggleEditar}
          Campo={Campo}
          ValorCampo={ValorCampo}
          IDCampo={IDCampo}
          Tipo={Tipo}
          id={id}
          token={token}
          setCampo={setCampo}
          setValorCampo={setValorCampo}
          setIDCampo={setIDCampo}
          setTipo={setTipo}
          PresupuestosGetService={PresupuestosGetService}
        />
      )}
      {ModalEditarPresu && (
        <ModalEditarPre
          ModalEditarPresu={ModalEditarPresu}
          toggleEditarPre={toggleEditarPre}
          IdPresupuesto={IdPresupuesto}
          id={id}
          token={token}
          cliente_id={cliente_id}
          PresupuestosGetService={PresupuestosGetService}
          PadresMontoGetService={PadresMontoGetService}
        />
      )}

      {ModalAportacion && (
        <ModalAddAportacion
          ModalAportacion={ModalAportacion}
          toggleAportacion={toggleAportacion}
          Monto={Monto}
          setMonto={setMonto}
          IdAportacion={IdAportacion}
          id={id}
          token={token}
          PresupuestosGetService={PresupuestosGetService}
        />
      )}

      <section style={{paddingTop: 10, paddingBottom: 50}}>
        <div className="container">
          <div className="crud-header">
            <Title
              title={
                Proyecto?.nombre
                  ? `${Proyecto.nombre} · Presupuesto`
                  : "Presupuestos"
              }
              className="crud-title"
            />
            <div className="d-flex gap-2">
              {Proyecto && (
                <VersionesPresupuesto
                  proyectoId={Proyecto.id}
                  token={token}
                  onCambio={() => PresupuestosGetService(id, token)}
                />
              )}
              {canManage && (
                <button
                  className="crud-add-btn"
                  onClick={() => setNuevaCuenta((abierto) => !abierto)}
                >
                  <i className="bi bi-plus-lg"></i>
                  Agregar cuenta padre
                </button>
              )}
              {canManage && Proyecto && (
                <BotonesExcel
                  proyecto={Proyecto}
                  token={token}
                  onImportado={() => PresupuestosGetService(id, token)}
                  ocultarDescargar
                />
              )}
              <button className="crud-secondary-btn" onClick={generateExcel} disabled={exportando}>
                <i className="bi bi-file-earmark-excel"></i>
                {exportando ? "Exportando..." : "Exportar presupuesto"}
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="crud-card">
                <GroupedTable tableKey="presupuestos" loading={loading}
                  data={Presupuestos}
                  groupField="grupo"
                  columns={parentColumns}
                  subRows={(fila) => fila.children}
                  onReordenar={reordenar}
                  borradorArriba={
                    NuevaCuenta ? (
                      <FilaNueva
                        tipo="cuenta"
                        sugerirCuenta={siguienteCuentaPadre}
                        onGuardar={guardarCuenta}
                        onCancelar={() => setNuevaCuenta(false)}
                      />
                    ) : null
                  }
                  borradorEn={(fila, nivel) =>
                    !!Borrador &&
                    Borrador.tipo !== "concepto" &&
                    Borrador.filaId === fila.id &&
                    Borrador.esPadre === (nivel === 0)
                  }
                  renderBorrador={() => (
                    <FilaNueva
                      key={`${Borrador.filaId}-${Borrador.tipo}-${Borrador.cuentaSugerida}`}
                      tipo={Borrador.tipo}
                      cuentaSugerida={Borrador.cuentaSugerida}
                      token={token}
                      clienteId={Proyecto?.clientes_id}
                      onGuardar={guardarBorrador}
                      onCancelar={() => setBorrador(null)}
                    />
                  )}
                  aggregates={[
                    {field: "monto", label: "Subtotal"},
                    {field: "iva", label: "IVA"},
                    {field: "total", label: "Total"},
                  ]}
                  formatCurrency={formatCurrency}
                />
              </div>
            </div>

            <Modal
              size="xl"
              isOpen={!!Borrador && Borrador.tipo === "concepto"}
              toggle={() => setBorrador(null)}
            >
              <ModalHeader toggle={() => setBorrador(null)}>
                Agregar concepto
              </ModalHeader>
              <ModalBody>
                {Borrador && Borrador.tipo === "concepto" && (
                  <FilaNueva
                    key={`${Borrador.filaId}-${Borrador.tipo}-${Borrador.cuentaSugerida}`}
                    tipo={Borrador.tipo}
                    cuentaSugerida={Borrador.cuentaSugerida}
                    token={token}
                    clienteId={Proyecto?.clientes_id}
                    onGuardar={guardarBorrador}
                    onCancelar={() => setBorrador(null)}
                  />
                )}
              </ModalBody>
            </Modal>
          </div>

        </div>
      </section>
    </>
  );
}
